import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgViceCaptain = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	role: "img",
	focusable: "false",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 12,
		cy: 12,
		r: 12,
		"aria-hidden": "true"
	}), /* @__PURE__ */ _jsx("polygon", {
		points: "13.5 .375 8.925 12.375 4.65 12.375 0 .375 3.15 .375 6.75 10.05 10.35 .375",
		transform: "translate(5.25 6)",
		fill: "currentColor",
		"aria-hidden": "true"
	})]
});
export default SvgViceCaptain;
